
/** 路由名称 */
export enum ERouterName {
  outsideWx = 'outsideWx',
}
